import axios from "axios";

// export const FILE_API_ENDPOINT = "https://dev.iggietech.in/outletacemain/";
// export const FILE_API_ENDPOINT = "http://192.168.29.72:3033/hms";
// export const FILE_API_ENDPOINT = "http://localhost:3033/hms";
// export const FILE_API_ENDPOINT = "https://oracle.iggietech.in/hms/";
export const FILE_API_ENDPOINT = "https://mathiroerp.inzpire.in/hms/";
// export const FRAPPE_DIRECT_URL = "http://192.168.29.72:8080";
export const FRAPPE_DIRECT_URL = "https://mathiroerp.inzpire.in";
export const API_ENDPOINT = `${FILE_API_ENDPOINT}`;

export const getAxiosInstance = () => {
    var axiosInstance = axios.create({
        timeout: 1000 * 60
    });
    axiosInstance.defaults.baseURL = API_ENDPOINT;
    return axiosInstance;
};

var axiosInstance = getAxiosInstance();
axiosInstance.interceptors.request.use(
    function (config) {
        console.log(config.url);
        if (config.url === "users/login") {
            return config;
        } else {
            let authToken = window.localStorage.getItem("outletace_jwt");
            console.log("Checking", authToken);
            console.log(authToken);
            config.headers["Authorization"] = `Bearer ${authToken}`;
        }
        return config;
    },
    function (error) {
        console.log(error);
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;

        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const refreshToken = window.localStorage.getItem("outletace_refresh_token");

            if (refreshToken) {
                try {
                    const tokenResponse = await axios.post(`${API_ENDPOINT}/users/refresh/token`, {
                        token: refreshToken,
                    });

                    const newAccessToken = tokenResponse.data.token;
                    window.localStorage.setItem("outletace_jwt", newAccessToken);

                    // Important: update the header before retrying
                    originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

                    return axiosInstance(originalRequest); // Retry original request
                } catch (err) {
                    console.error("Token refresh failed", err);
                    window.localStorage.clear();
                    window.location.reload();
                }
            } else {
                window.localStorage.clear();
                window.location.reload();
            }
        }

        return Promise.reject(error);
    }
);  

export const fetchLogin = (username, password) => {
    return axiosInstance.post(
        "users/login",
        {
            username: username,
            password: password
        },
        {}
    );
};
export const getReportData = (details) => {
    return axiosInstance.post(`frappe/api/method/frappe.desk.reportview.get`, details, {});
};
export const getUserCompany = (username) => {
    return axiosInstance.get(`frappe/api/resource/User Permission?fields=["user", "allow", "for_value"]&filters=[["allow", "=", "Company"], ["user","=", "${username}"]]`);
}
export const getLoggedInUser = () => {
    return axiosInstance.get(`frappe/api/method/frappe.auth.get_logged_user`);
}
export const createPackage = (payload) => {
    return axiosInstance.post(`frappe/api/method/frappe.desk.form.save.savedocs`, payload);
};

export const fetchRoomTypes = (params) => {
    return axiosInstance.get(`/frappe/api/method/frappe.desk.reportview.get`, { params });
};

export const fetchPackageList = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};

export const fetchPackageDetails = (name) => {
    return axiosInstance.get(`/frappe/api/resource/Room Package/${name}`);
};

export const updatePackage = (name, fields) => {
    return axiosInstance.put(`/frappe/api/resource/Room Package/${name}`, fields);
};

export const updatePackageDetails = (name, fields) => {
    return axiosInstance.put(`/frappe/api/resource/Package Details/${name}`, fields);
};


export const fetchRoomList = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};

export const updateRoomPackage = (packageName, packageData) => {
    return axiosInstance.put(`/frappe/api/resource/Room Package/${packageName}`, packageData
    );
};
export const fetchReservationList = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};



export const fetchRoomNo = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};


export const createGuestandReservation = (payload) => {
    return axiosInstance.post(`/frappe/api/method/frappe.desk.form.save.savedocs`, payload);
};

export const getReservationDetails = (reservationId) => {
    return axiosInstance.get(`/frappe/api/resource/Reservation/${reservationId}`);
};

export const fetchMaintenanceList = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};

export const fetchIssueCategory = (params) => {
    return axiosInstance.get(`/frappe/api/method/frappe.desk.reportview.get`, { params });
};

export const createMaintenance = (payload) => {
    return axiosInstance.post(`/frappe/api/method/frappe.desk.form.save.savedocs`, payload);
};

export const updateMaintenance = (id, fields) => {
    return axiosInstance.put(`/frappe/api/resource/Room Maintenance/${id}`, fields);
};

export const updateReservation = (reservationId, payload) => {
    return axiosInstance.put(`/frappe/api/resource/Reservation/${reservationId}`, payload);
};

// In your API service file (e.g., service/network.js)
export const fetchGuestDetailsByMobile = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};

export const checkInReservation = (payload) => {
    return axiosInstance.post('/frappe/api/method/check_in', payload);
};
export const checkOutReservation = (payload) => {
    return axiosInstance.put('/frappe/api/method/check_out', payload);
};
export const CancelReservation = (payload) => {
    return axiosInstance.post('/frappe/api/method/check_out', payload);
};
export const runReportData = (details) => {
    return axiosInstance.post("frappe/api/method/frappe.desk.query_report.run", details);
}

export const getUnallocatedAmount = (details) => {
    return axiosInstance.post("frappe/api/method/unallocatedamount", details);
}

export const addGuestPayment = (details) => {
    return axiosInstance.post("frappe/api/method/guestpayment", details);
}

export const getItemTaxTemplateDetails = (id) => {
    return axiosInstance.get(`/frappe/api/resource/Item Tax Template/${id}`);
}

export const getGuestCustomer = (details) => {
    return axiosInstance.post(`/frappe/api/method/getGuestCustomer`, details);
}

export const saveDocs = (payload) => {
    return axiosInstance.post(`/frappe/api/method/frappe.desk.form.save.savedocs`, payload);
};

export const getSalesInvoiceDetails = (id) => {
    return axiosInstance.get(`/frappe/api/resource/Sales Invoice/${id}`);
}

export const markInvoicepayment = (details) => {
    return axiosInstance.post(`/frappe/api/method/markinvoicepayment`, details);
}

export const consumeService = (details) => {
    return axiosInstance.post(`/frappe/api/method/availservice`, details);
}

export const estimatetariff = (details) => {
    return axiosInstance.post(`/frappe/api/method/estimatetariff`, details);
}

export const getPrintFormatInvoice = () => {
    return axiosInstance.post(`/frappe/api/method/printformat`, {});
}

export const printFile = (params) => {
    return axiosInstance.get(`frappe/api/method/frappe.utils.print_format.download_pdf${params ? `?${params}` : ``}`, { responseType: 'blob' });
}

export const uploadFrappeMedia = (formData) => {
    return axiosInstance.post(`frappe/api/method/upload_file`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}
export const addTag = (params) => {
    return axiosInstance.post('frappe/api/method/frappe.desk.doctype.tag.tag.add_tag', params, {});
};
export const updateFileAttachment = ({ fileName, attached_to_doctype, attached_to_name }) => {
    return axiosInstance.put(
        `/frappe/api/resource/File/${fileName}`,
        {
            attached_to_doctype,
            attached_to_name
        }
    );
};

export const updateRoom = (id, fields) => {
    return axiosInstance.put(`/frappe/api/resource/Room/${id}`, fields);
};

export const getDocInfoComplete = (details) => {
    return axiosInstance.post(`/frappe/api/method/frappe.desk.form.load.getdoc`, details);
}

export const getFileDetails = (id) => {
    return axiosInstance.get(`/frappe/api/resource/File/${id}`);
}

export const retrievefile = (url) => {
    return axiosInstance.get(`frappe/${url}`, { responseType: 'blob' });
}

export const fetchBlockingReason = (params) => {
    return axiosInstance.get(`/frappe/api/method/frappe.desk.reportview.get`, { params });
};

export const fetchRoomBlockingList = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};

export const createBlockList = (payload) => {
    return axiosInstance.post(`/frappe/api/method/frappe.desk.form.save.savedocs`, payload);
};

export const updateBlockList = (id, fields) => {
    return axiosInstance.put(`/frappe/api/resource/Room Blockings/${id}`, fields);
};
export const CreateCustomer = (details) => {
    return axiosInstance.post(`/frappe/api/resource/Customer`, details, {});
};
export const CreateCustomerAddress = (details) => {
    return axiosInstance.post(`/frappe/api/resource/Address`, details, {});
};
export const CreateCustomerContact = (details) => {
    return axiosInstance.post(`/frappe/api/resource/Contact`, details, {});
}
export const getStatesByCountry = (country) => {
    return axiosInstance.post("https://countriesnow.space/api/v0.1/countries/states", { country, });
};
export const fetchStateList = (country) => {
    return axiosInstance.post("https://countriesnow.space/api/v0.1/countries/states", { country, });
};
export const fetchCountryList = (params) => {
    return axiosInstance.get('/frappe/api/method/frappe.desk.reportview.get', { params });
};
export const getCustomerDetails = (customer, params) => 
{return axiosInstance.get(`frappe/api/method/frappe.desk.form.load.getdoc?doctype=Customer&name=${customer}${params ? `&${params}` : ``}`,
        {}
    );
};


export const updateAddress = (address, details) => {
    return axiosInstance.put(`/frappe/api/resource/Address/${address}`, details, {});
};
export const updateContact = (contact, details) => {
    return axiosInstance.put(`/frappe/api/resource/Contact/${contact}`, details, {});
}
export const getAddressDetails = (address, params) => {
    return axiosInstance.get(`frappe/api/resource/Address/${address}${params ? `?${params}` : ``}`, {});
}

export const getContactDetails = (contact, params) => {
    return axiosInstance.get(`frappe/api/resource/Contact/${contact}${params ? `?${params}` : ``}`, {});
}



export const updateCustomer = (customer, details) => {
    return axiosInstance.put(`/frappe/api/resource/Customer/${customer}`, details, {});
};

export const setDocValue = (args) => {
    return axiosInstance.post(
        "frappe/api/method/frappe.client.set_value",
        args
    );
    
};
export const updateChildAttachment = (payload) => {
  return axiosInstance.post("/updateChildAttachment", payload);
};